// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/static/fonts/Nord-Light.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  scroll-behavior: smooth;
}
body {
  zoom: 65%;
  width: 100%;
  height: 100%;
  font-family: poppins;
  background-color: #171717;
  background-position: center;
  /* - Test - animated background */

  /* background: linear-gradient(60deg, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a);
  background-size: 50% 20%;
  animation: gradientMove 10s linear infinite; */
}
@font-face {
  font-family: "Nord";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
/*-------------------------------------------------------------------Privacy and more------------------------------------------------------------*/
#hyperlink-container {
  display: flex;
  justify-content: center;
  margin: 0px 20px 100px 20px;
}

.hyperlink {
  margin: 0 50px;
  text-decoration: none;
  color: #757575;
  font-size: 110%;
  font-family: 'Nord';
  font-style: normal;
}

#links-row {
  display: flex;
  justify-content: space-between;
}
.link-content.active {
  display: block;
}


.link-content-titles{
  font-family: 'Nord';
  font-style: normal;
  font-weight: 400;
  font-size: 300%;
  margin-bottom: 100px;
  color: white;
}
#privacy-notice {
  margin: 200px auto 300px auto;
  width: 90vw;
}
#delivery-information {
  margin: 200px auto 300px auto;
  width: 90vw;
}
#terms-of-service {
  margin: 200px auto 300px auto;
  width: 90vw;
}

.lst-kix_4z4oebq2d6xw-8>li:before {
  content: "\\0025a0   "
}

.lst-kix_4z4oebq2d6xw-7>li:before {
  content: "\\0025cb   "
}

.lst-kix_4z4oebq2d6xw-6>li:before {
  content: "\\0025cf   "
}

ul.lst-kix_bd987uo7pqus-0 {
  list-style-type: none
}

ul.lst-kix_bd987uo7pqus-1 {
  list-style-type: none
}

ul.lst-kix_bd987uo7pqus-2 {
  list-style-type: none
}

ul.lst-kix_dxfyrqkomy19-4 {
  list-style-type: none
}

ol.lst-kix_i70phmy36es7-8 {
  list-style-type: none
}

ul.lst-kix_bd987uo7pqus-3 {
  list-style-type: none
}

ul.lst-kix_dxfyrqkomy19-3 {
  list-style-type: none
}

ol.lst-kix_i70phmy36es7-7 {
  list-style-type: none
}

ul.lst-kix_bd987uo7pqus-4 {
  list-style-type: none
}

ul.lst-kix_dxfyrqkomy19-6 {
  list-style-type: none
}

ul.lst-kix_bd987uo7pqus-5 {
  list-style-type: none
}

ul.lst-kix_dxfyrqkomy19-5 {
  list-style-type: none
}

ul.lst-kix_bd987uo7pqus-6 {
  list-style-type: none
}

ul.lst-kix_dxfyrqkomy19-8 {
  list-style-type: none
}

ul.lst-kix_bd987uo7pqus-7 {
  list-style-type: none
}

ul.lst-kix_dxfyrqkomy19-7 {
  list-style-type: none
}

ul.lst-kix_bd987uo7pqus-8 {
  list-style-type: none
}

ul.lst-kix_k1hodgudwc6-8 {
  list-style-type: none
}

ul.lst-kix_k1hodgudwc6-7 {
  list-style-type: none
}

ul.lst-kix_k1hodgudwc6-6 {
  list-style-type: none
}

ol.lst-kix_i70phmy36es7-1.start {
  counter-reset: lst-ctn-kix_i70phmy36es7-1 0
}

ol.lst-kix_i70phmy36es7-7.start {
  counter-reset: lst-ctn-kix_i70phmy36es7-7 0
}

ul.lst-kix_k1hodgudwc6-1 {
  list-style-type: none
}

ul.lst-kix_k1hodgudwc6-0 {
  list-style-type: none
}

ul.lst-kix_k1hodgudwc6-5 {
  list-style-type: none
}

ul.lst-kix_k1hodgudwc6-4 {
  list-style-type: none
}

ul.lst-kix_k1hodgudwc6-3 {
  list-style-type: none
}

ol.lst-kix_rtfebb3v4zx2-2.start {
  counter-reset: lst-ctn-kix_rtfebb3v4zx2-2 0
}

ul.lst-kix_k1hodgudwc6-2 {
  list-style-type: none
}

.lst-kix_rtfebb3v4zx2-3>li:before {
  content: "" counter(lst-ctn-kix_rtfebb3v4zx2-3, decimal) ". "
}

.lst-kix_rtfebb3v4zx2-2>li:before {
  content: "" counter(lst-ctn-kix_rtfebb3v4zx2-2, lower-roman) ". "
}

.lst-kix_rtfebb3v4zx2-4>li:before {
  content: "" counter(lst-ctn-kix_rtfebb3v4zx2-4, lower-latin) ". "
}

.lst-kix_rtfebb3v4zx2-1>li:before {
  content: "" counter(lst-ctn-kix_rtfebb3v4zx2-1, lower-latin) ". "
}

.lst-kix_rtfebb3v4zx2-5>li:before {
  content: "" counter(lst-ctn-kix_rtfebb3v4zx2-5, lower-roman) ". "
}

.lst-kix_rtfebb3v4zx2-2>li {
  counter-increment: lst-ctn-kix_rtfebb3v4zx2-2
}

.lst-kix_5cy47ievptas-0>li:before {
  content: "\\0025cf   "
}

ol.lst-kix_rtfebb3v4zx2-8.start {
  counter-reset: lst-ctn-kix_rtfebb3v4zx2-8 0
}

.lst-kix_5cy47ievptas-1>li:before {
  content: "\\0025cb   "
}

.lst-kix_5cy47ievptas-3>li:before {
  content: "\\0025cf   "
}

.lst-kix_5cy47ievptas-2>li:before {
  content: "\\0025a0   "
}

ul.lst-kix_5nqdbtxdbgr4-8 {
  list-style-type: none
}

ul.lst-kix_5nqdbtxdbgr4-6 {
  list-style-type: none
}

ul.lst-kix_5nqdbtxdbgr4-7 {
  list-style-type: none
}

.lst-kix_rtfebb3v4zx2-0>li:before {
  content: "" counter(lst-ctn-kix_rtfebb3v4zx2-0, decimal) ". "
}

ul.lst-kix_5nqdbtxdbgr4-4 {
  list-style-type: none
}

ul.lst-kix_5nqdbtxdbgr4-5 {
  list-style-type: none
}

ul.lst-kix_5nqdbtxdbgr4-2 {
  list-style-type: none
}

ul.lst-kix_5nqdbtxdbgr4-3 {
  list-style-type: none
}

ul.lst-kix_5nqdbtxdbgr4-0 {
  list-style-type: none
}

ul.lst-kix_5nqdbtxdbgr4-1 {
  list-style-type: none
}

.lst-kix_i70phmy36es7-0>li {
  counter-increment: lst-ctn-kix_i70phmy36es7-0
}

ol.lst-kix_i70phmy36es7-6.start {
  counter-reset: lst-ctn-kix_i70phmy36es7-6 0
}

.lst-kix_wwac6hxnt0l-6>li:before {
  content: "\\0025cf   "
}

.lst-kix_i70phmy36es7-7>li {
  counter-increment: lst-ctn-kix_i70phmy36es7-7
}

ol.lst-kix_rtfebb3v4zx2-7.start {
  counter-reset: lst-ctn-kix_rtfebb3v4zx2-7 0
}

.lst-kix_5cy47ievptas-5>li:before {
  content: "\\0025a0   "
}

.lst-kix_5cy47ievptas-7>li:before {
  content: "\\0025cb   "
}

.lst-kix_wwac6hxnt0l-4>li:before {
  content: "\\0025cb   "
}

.lst-kix_wwac6hxnt0l-8>li:before {
  content: "\\0025a0   "
}

.lst-kix_wwac6hxnt0l-5>li:before {
  content: "\\0025a0   "
}

.lst-kix_5cy47ievptas-4>li:before {
  content: "\\0025cb   "
}

.lst-kix_5cy47ievptas-8>li:before {
  content: "\\0025a0   "
}

.lst-kix_wwac6hxnt0l-7>li:before {
  content: "\\0025cb   "
}

.lst-kix_5cy47ievptas-6>li:before {
  content: "\\0025cf   "
}

.lst-kix_wwac6hxnt0l-0>li:before {
  content: "\\0025cf   "
}

.lst-kix_wwac6hxnt0l-1>li:before {
  content: "\\0025cb   "
}

.lst-kix_rf5ciq3y790d-8>li:before {
  content: "-  "
}

.lst-kix_wwac6hxnt0l-2>li:before {
  content: "\\0025a0   "
}

.lst-kix_rf5ciq3y790d-5>li:before {
  content: "-  "
}

.lst-kix_rf5ciq3y790d-7>li:before {
  content: "-  "
}

.lst-kix_wwac6hxnt0l-3>li:before {
  content: "\\0025cf   "
}

.lst-kix_rf5ciq3y790d-6>li:before {
  content: "-  "
}

.lst-kix_rf5ciq3y790d-1>li:before {
  content: "-  "
}

.lst-kix_rf5ciq3y790d-3>li:before {
  content: "-  "
}

.lst-kix_rf5ciq3y790d-0>li:before {
  content: "-  "
}

.lst-kix_rf5ciq3y790d-4>li:before {
  content: "-  "
}

.lst-kix_rtfebb3v4zx2-0>li {
  counter-increment: lst-ctn-kix_rtfebb3v4zx2-0
}

.lst-kix_rf5ciq3y790d-2>li:before {
  content: "-  "
}

.lst-kix_bd987uo7pqus-1>li:before {
  content: "\\0025cb   "
}

.lst-kix_rtfebb3v4zx2-6>li {
  counter-increment: lst-ctn-kix_rtfebb3v4zx2-6
}

.lst-kix_bd987uo7pqus-3>li:before {
  content: "\\0025cf   "
}

ul.lst-kix_pqfk9eb5xg9l-0 {
  list-style-type: none
}

.lst-kix_i70phmy36es7-0>li:before {
  content: "" counter(lst-ctn-kix_i70phmy36es7-0, decimal) ". "
}

ul.lst-kix_pqfk9eb5xg9l-1 {
  list-style-type: none
}

ul.lst-kix_pqfk9eb5xg9l-2 {
  list-style-type: none
}

ul.lst-kix_pqfk9eb5xg9l-3 {
  list-style-type: none
}

ul.lst-kix_pqfk9eb5xg9l-4 {
  list-style-type: none
}

ul.lst-kix_pqfk9eb5xg9l-5 {
  list-style-type: none
}

.lst-kix_i70phmy36es7-2>li:before {
  content: "" counter(lst-ctn-kix_i70phmy36es7-2, lower-roman) ". "
}

ul.lst-kix_pqfk9eb5xg9l-6 {
  list-style-type: none
}

ul.lst-kix_pqfk9eb5xg9l-7 {
  list-style-type: none
}

.lst-kix_5nqdbtxdbgr4-0>li:before {
  content: "\\0025cf   "
}

ul.lst-kix_pqfk9eb5xg9l-8 {
  list-style-type: none
}

.lst-kix_1mz2712tijq9-7>li:before {
  content: "\\0025c6   "
}

.lst-kix_5nqdbtxdbgr4-2>li:before {
  content: "\\0025a0   "
}

.lst-kix_2a03qcigu0f2-8>li:before {
  content: "\\0025a0   "
}

.lst-kix_5nqdbtxdbgr4-4>li:before {
  content: "\\0025cb   "
}

.lst-kix_rtfebb3v4zx2-5>li {
  counter-increment: lst-ctn-kix_rtfebb3v4zx2-5
}

.lst-kix_i70phmy36es7-8>li:before {
  content: "" counter(lst-ctn-kix_i70phmy36es7-8, lower-roman) ". "
}

.lst-kix_i70phmy36es7-4>li:before {
  content: "" counter(lst-ctn-kix_i70phmy36es7-4, lower-latin) ". "
}

.lst-kix_1mz2712tijq9-5>li:before {
  content: "\\0025cf   "
}

.lst-kix_byj4xjdm9nqi-7>li:before {
  content: "\\0025cb   "
}

.lst-kix_1mz2712tijq9-3>li:before {
  content: "\\0025cb   "
}

ol.lst-kix_rtfebb3v4zx2-1.start {
  counter-reset: lst-ctn-kix_rtfebb3v4zx2-1 0
}

ol.lst-kix_rtfebb3v4zx2-4 {
  list-style-type: none
}

.lst-kix_1mz2712tijq9-1>li:before {
  content: "\\0025c6   "
}

ol.lst-kix_rtfebb3v4zx2-3 {
  list-style-type: none
}

.lst-kix_i70phmy36es7-3>li {
  counter-increment: lst-ctn-kix_i70phmy36es7-3
}

ol.lst-kix_rtfebb3v4zx2-6 {
  list-style-type: none
}

ol.lst-kix_i70phmy36es7-0.start {
  counter-reset: lst-ctn-kix_i70phmy36es7-0 0
}

ol.lst-kix_i70phmy36es7-3.start {
  counter-reset: lst-ctn-kix_i70phmy36es7-3 0
}

ol.lst-kix_rtfebb3v4zx2-5 {
  list-style-type: none
}

ol.lst-kix_rtfebb3v4zx2-8 {
  list-style-type: none
}

.lst-kix_i70phmy36es7-6>li:before {
  content: "" counter(lst-ctn-kix_i70phmy36es7-6, decimal) ". "
}

ol.lst-kix_rtfebb3v4zx2-7 {
  list-style-type: none
}

ol.lst-kix_rtfebb3v4zx2-0 {
  list-style-type: none
}

ol.lst-kix_rtfebb3v4zx2-2 {
  list-style-type: none
}

ol.lst-kix_rtfebb3v4zx2-1 {
  list-style-type: none
}

.lst-kix_1s8qgf4ntfy6-7>li:before {
  content: "\\0025cb   "
}

ol.lst-kix_i70phmy36es7-2.start {
  counter-reset: lst-ctn-kix_i70phmy36es7-2 0
}

ol.lst-kix_rtfebb3v4zx2-4.start {
  counter-reset: lst-ctn-kix_rtfebb3v4zx2-4 0
}

.lst-kix_1s8qgf4ntfy6-3>li:before {
  content: "\\0025cf   "
}

.lst-kix_rtfebb3v4zx2-4>li {
  counter-increment: lst-ctn-kix_rtfebb3v4zx2-4
}

.lst-kix_1s8qgf4ntfy6-1>li:before {
  content: "\\0025cb   "
}

.lst-kix_1s8qgf4ntfy6-5>li:before {
  content: "\\0025a0   "
}

.lst-kix_rtfebb3v4zx2-7>li:before {
  content: "" counter(lst-ctn-kix_rtfebb3v4zx2-7, lower-latin) ". "
}

.lst-kix_qthp0cfoiw80-3>li:before {
  content: "-  "
}

.lst-kix_qthp0cfoiw80-5>li:before {
  content: "-  "
}

.lst-kix_qthp0cfoiw80-7>li:before {
  content: "-  "
}

ol.lst-kix_rtfebb3v4zx2-3.start {
  counter-reset: lst-ctn-kix_rtfebb3v4zx2-3 0
}

.lst-kix_5nqdbtxdbgr4-6>li:before {
  content: "\\0025cf   "
}

.lst-kix_i70phmy36es7-8>li {
  counter-increment: lst-ctn-kix_i70phmy36es7-8
}

.lst-kix_2a03qcigu0f2-6>li:before {
  content: "\\0025cf   "
}

.lst-kix_2a03qcigu0f2-4>li:before {
  content: "\\0025cb   "
}

.lst-kix_i70phmy36es7-2>li {
  counter-increment: lst-ctn-kix_i70phmy36es7-2
}

.lst-kix_5nqdbtxdbgr4-8>li:before {
  content: "\\0025a0   "
}

.lst-kix_2a03qcigu0f2-2>li:before {
  content: "\\0025a0   "
}

.lst-kix_4z4oebq2d6xw-1>li:before {
  content: "\\0025cb   "
}

.lst-kix_4z4oebq2d6xw-3>li:before {
  content: "\\0025cf   "
}

.lst-kix_4z4oebq2d6xw-5>li:before {
  content: "\\0025a0   "
}

.lst-kix_2a03qcigu0f2-0>li:before {
  content: "\\0025cf   "
}

ul.lst-kix_rf5ciq3y790d-3 {
  list-style-type: none
}

.lst-kix_kjj132141nex-4>li:before {
  content: "\\0025cb   "
}

ul.lst-kix_lc6lbngtx2du-7 {
  list-style-type: none
}

ul.lst-kix_rf5ciq3y790d-4 {
  list-style-type: none
}

ol.lst-kix_i70phmy36es7-4.start {
  counter-reset: lst-ctn-kix_i70phmy36es7-4 0
}

ul.lst-kix_lc6lbngtx2du-6 {
  list-style-type: none
}

ul.lst-kix_rf5ciq3y790d-5 {
  list-style-type: none
}

.lst-kix_kjj132141nex-3>li:before {
  content: "\\0025cf   "
}

.lst-kix_kjj132141nex-5>li:before {
  content: "\\0025a0   "
}

ul.lst-kix_lc6lbngtx2du-5 {
  list-style-type: none
}

ul.lst-kix_rf5ciq3y790d-6 {
  list-style-type: none
}

ul.lst-kix_lc6lbngtx2du-4 {
  list-style-type: none
}

ul.lst-kix_rf5ciq3y790d-7 {
  list-style-type: none
}

ul.lst-kix_lc6lbngtx2du-3 {
  list-style-type: none
}

ul.lst-kix_rf5ciq3y790d-8 {
  list-style-type: none
}

ul.lst-kix_lc6lbngtx2du-2 {
  list-style-type: none
}

ul.lst-kix_lc6lbngtx2du-1 {
  list-style-type: none
}

ul.lst-kix_lc6lbngtx2du-0 {
  list-style-type: none
}

.lst-kix_kjj132141nex-0>li:before {
  content: "\\0025cf   "
}

.lst-kix_kjj132141nex-8>li:before {
  content: "\\0025a0   "
}

.lst-kix_lc6lbngtx2du-0>li:before {
  content: "\\0025cf   "
}

.lst-kix_kjj132141nex-1>li:before {
  content: "\\0025cb   "
}

.lst-kix_pqfk9eb5xg9l-0>li:before {
  content: "\\0025cf   "
}

.lst-kix_kjj132141nex-2>li:before {
  content: "\\0025a0   "
}

.lst-kix_lc6lbngtx2du-2>li:before {
  content: "\\0025a0   "
}

ul.lst-kix_rf5ciq3y790d-0 {
  list-style-type: none
}

ul.lst-kix_rf5ciq3y790d-1 {
  list-style-type: none
}

.lst-kix_lc6lbngtx2du-1>li:before {
  content: "\\0025cb   "
}

ul.lst-kix_rf5ciq3y790d-2 {
  list-style-type: none
}

ul.lst-kix_lc6lbngtx2du-8 {
  list-style-type: none
}

.lst-kix_lc6lbngtx2du-4>li:before {
  content: "\\0025cb   "
}

.lst-kix_dxfyrqkomy19-1>li:before {
  content: "\\0025cb   "
}

.lst-kix_dxfyrqkomy19-0>li:before {
  content: "\\0025cf   "
}

.lst-kix_rtfebb3v4zx2-1>li {
  counter-increment: lst-ctn-kix_rtfebb3v4zx2-1
}

.lst-kix_lc6lbngtx2du-3>li:before {
  content: "\\0025cf   "
}

.lst-kix_lc6lbngtx2du-7>li:before {
  content: "\\0025cb   "
}

.lst-kix_kjj132141nex-7>li:before {
  content: "\\0025cb   "
}

.lst-kix_kjj132141nex-6>li:before {
  content: "\\0025cf   "
}

.lst-kix_lc6lbngtx2du-6>li:before {
  content: "\\0025cf   "
}

.lst-kix_lc6lbngtx2du-5>li:before {
  content: "\\0025a0   "
}

.lst-kix_dxfyrqkomy19-8>li:before {
  content: "\\0025a0   "
}

ul.lst-kix_wwac6hxnt0l-0 {
  list-style-type: none
}

ul.lst-kix_wwac6hxnt0l-1 {
  list-style-type: none
}

ul.lst-kix_wwac6hxnt0l-2 {
  list-style-type: none
}

.lst-kix_qthp0cfoiw80-2>li:before {
  content: "-  "
}

ol.lst-kix_rtfebb3v4zx2-5.start {
  counter-reset: lst-ctn-kix_rtfebb3v4zx2-5 0
}

.lst-kix_qthp0cfoiw80-1>li:before {
  content: "-  "
}

.lst-kix_pqfk9eb5xg9l-8>li:before {
  content: "\\0025a0   "
}

.lst-kix_qthp0cfoiw80-0>li:before {
  content: "-  "
}

.lst-kix_pqfk9eb5xg9l-7>li:before {
  content: "\\0025cb   "
}

.lst-kix_dxfyrqkomy19-2>li:before {
  content: "\\0025a0   "
}

.lst-kix_pqfk9eb5xg9l-5>li:before {
  content: "\\0025a0   "
}

.lst-kix_dxfyrqkomy19-3>li:before {
  content: "\\0025cf   "
}

.lst-kix_pqfk9eb5xg9l-4>li:before {
  content: "\\0025cb   "
}

.lst-kix_pqfk9eb5xg9l-6>li:before {
  content: "\\0025cf   "
}

.lst-kix_dxfyrqkomy19-4>li:before {
  content: "\\0025cb   "
}

.lst-kix_k1hodgudwc6-8>li:before {
  content: "\\0025a0   "
}

.lst-kix_dxfyrqkomy19-6>li:before {
  content: "\\0025cf   "
}

ul.lst-kix_wwac6hxnt0l-3 {
  list-style-type: none
}

.lst-kix_pqfk9eb5xg9l-1>li:before {
  content: "\\0025cb   "
}

.lst-kix_k1hodgudwc6-6>li:before {
  content: "\\0025cf   "
}

.lst-kix_k1hodgudwc6-7>li:before {
  content: "\\0025cb   "
}

ul.lst-kix_wwac6hxnt0l-4 {
  list-style-type: none
}

.lst-kix_dxfyrqkomy19-5>li:before {
  content: "\\0025a0   "
}

.lst-kix_dxfyrqkomy19-7>li:before {
  content: "\\0025cb   "
}

ul.lst-kix_wwac6hxnt0l-5 {
  list-style-type: none
}

.lst-kix_pqfk9eb5xg9l-2>li:before {
  content: "\\0025a0   "
}

ul.lst-kix_wwac6hxnt0l-6 {
  list-style-type: none
}

ul.lst-kix_wwac6hxnt0l-7 {
  list-style-type: none
}

.lst-kix_pqfk9eb5xg9l-3>li:before {
  content: "\\0025cf   "
}

ul.lst-kix_wwac6hxnt0l-8 {
  list-style-type: none
}

.lst-kix_k1hodgudwc6-2>li:before {
  content: "\\0025a0   "
}

.lst-kix_k1hodgudwc6-3>li:before {
  content: "\\0025cf   "
}

.lst-kix_ks5ooyhkhmj-7>li:before {
  content: "\\0025cb   "
}

.lst-kix_k1hodgudwc6-0>li:before {
  content: "\\0025cf   "
}

.lst-kix_k1hodgudwc6-1>li:before {
  content: "\\0025cb   "
}

.lst-kix_k1hodgudwc6-4>li:before {
  content: "\\0025cb   "
}

.lst-kix_k1hodgudwc6-5>li:before {
  content: "\\0025a0   "
}

.lst-kix_ks5ooyhkhmj-6>li:before {
  content: "\\0025cf   "
}

.lst-kix_byj4xjdm9nqi-6>li:before {
  content: "\\0025cf   "
}

.lst-kix_ks5ooyhkhmj-8>li:before {
  content: "\\0025a0   "
}

.lst-kix_byj4xjdm9nqi-5>li:before {
  content: "\\0025a0   "
}

.lst-kix_byj4xjdm9nqi-4>li:before {
  content: "\\0025cb   "
}

.lst-kix_byj4xjdm9nqi-1>li:before {
  content: "\\0025cb   "
}

.lst-kix_byj4xjdm9nqi-3>li:before {
  content: "\\0025cf   "
}

.lst-kix_i70phmy36es7-1>li {
  counter-increment: lst-ctn-kix_i70phmy36es7-1
}

.lst-kix_byj4xjdm9nqi-2>li:before {
  content: "\\0025a0   "
}

ol.lst-kix_i70phmy36es7-5.start {
  counter-reset: lst-ctn-kix_i70phmy36es7-5 0
}

.lst-kix_byj4xjdm9nqi-0>li:before {
  content: "\\0025cf   "
}

ul.lst-kix_qthp0cfoiw80-6 {
  list-style-type: none
}

ul.lst-kix_4z4oebq2d6xw-4 {
  list-style-type: none
}

ul.lst-kix_qthp0cfoiw80-7 {
  list-style-type: none
}

ul.lst-kix_4z4oebq2d6xw-3 {
  list-style-type: none
}

ul.lst-kix_qthp0cfoiw80-4 {
  list-style-type: none
}

ul.lst-kix_4z4oebq2d6xw-2 {
  list-style-type: none
}

ul.lst-kix_qthp0cfoiw80-5 {
  list-style-type: none
}

ul.lst-kix_4z4oebq2d6xw-1 {
  list-style-type: none
}

ul.lst-kix_4z4oebq2d6xw-8 {
  list-style-type: none
}

ul.lst-kix_4z4oebq2d6xw-7 {
  list-style-type: none
}

ul.lst-kix_qthp0cfoiw80-8 {
  list-style-type: none
}

ol.lst-kix_rtfebb3v4zx2-0.start {
  counter-reset: lst-ctn-kix_rtfebb3v4zx2-0 0
}

ul.lst-kix_4z4oebq2d6xw-6 {
  list-style-type: none
}

ul.lst-kix_byj4xjdm9nqi-8 {
  list-style-type: none
}

ul.lst-kix_4z4oebq2d6xw-5 {
  list-style-type: none
}

.lst-kix_ks5ooyhkhmj-0>li:before {
  content: "\\0025cf   "
}

ul.lst-kix_byj4xjdm9nqi-7 {
  list-style-type: none
}

ul.lst-kix_byj4xjdm9nqi-6 {
  list-style-type: none
}

ol.lst-kix_rtfebb3v4zx2-6.start {
  counter-reset: lst-ctn-kix_rtfebb3v4zx2-6 0
}

ul.lst-kix_byj4xjdm9nqi-5 {
  list-style-type: none
}

ul.lst-kix_byj4xjdm9nqi-4 {
  list-style-type: none
}

.lst-kix_ks5ooyhkhmj-1>li:before {
  content: "\\0025cb   "
}

ul.lst-kix_qthp0cfoiw80-2 {
  list-style-type: none
}

ul.lst-kix_byj4xjdm9nqi-3 {
  list-style-type: none
}

ul.lst-kix_4z4oebq2d6xw-0 {
  list-style-type: none
}

ul.lst-kix_qthp0cfoiw80-3 {
  list-style-type: none
}

ul.lst-kix_byj4xjdm9nqi-2 {
  list-style-type: none
}

.lst-kix_bd987uo7pqus-7>li:before {
  content: "\\0025cb   "
}

.lst-kix_bd987uo7pqus-8>li:before {
  content: "\\0025a0   "
}

ul.lst-kix_qthp0cfoiw80-0 {
  list-style-type: none
}

ul.lst-kix_byj4xjdm9nqi-1 {
  list-style-type: none
}

ul.lst-kix_qthp0cfoiw80-1 {
  list-style-type: none
}

ul.lst-kix_byj4xjdm9nqi-0 {
  list-style-type: none
}

.lst-kix_ks5ooyhkhmj-2>li:before {
  content: "\\0025a0   "
}

.lst-kix_rtfebb3v4zx2-3>li {
  counter-increment: lst-ctn-kix_rtfebb3v4zx2-3
}

.lst-kix_bd987uo7pqus-5>li:before {
  content: "\\0025a0   "
}

.lst-kix_bd987uo7pqus-6>li:before {
  content: "\\0025cf   "
}

.lst-kix_ks5ooyhkhmj-3>li:before {
  content: "\\0025cf   "
}

.lst-kix_ks5ooyhkhmj-5>li:before {
  content: "\\0025a0   "
}

.lst-kix_ks5ooyhkhmj-4>li:before {
  content: "\\0025cb   "
}

ul.lst-kix_2a03qcigu0f2-7 {
  list-style-type: none
}

ul.lst-kix_5cy47ievptas-0 {
  list-style-type: none
}

ul.lst-kix_2a03qcigu0f2-6 {
  list-style-type: none
}

.lst-kix_bd987uo7pqus-2>li:before {
  content: "\\0025a0   "
}

ul.lst-kix_1s8qgf4ntfy6-1 {
  list-style-type: none
}

ul.lst-kix_5cy47ievptas-1 {
  list-style-type: none
}

ul.lst-kix_2a03qcigu0f2-5 {
  list-style-type: none
}

ul.lst-kix_1s8qgf4ntfy6-0 {
  list-style-type: none
}

ul.lst-kix_5cy47ievptas-2 {
  list-style-type: none
}

ul.lst-kix_2a03qcigu0f2-4 {
  list-style-type: none
}

ul.lst-kix_1s8qgf4ntfy6-3 {
  list-style-type: none
}

ul.lst-kix_5cy47ievptas-3 {
  list-style-type: none
}

ul.lst-kix_2a03qcigu0f2-3 {
  list-style-type: none
}

ul.lst-kix_1s8qgf4ntfy6-2 {
  list-style-type: none
}

ul.lst-kix_5cy47ievptas-4 {
  list-style-type: none
}

ul.lst-kix_2a03qcigu0f2-2 {
  list-style-type: none
}

.lst-kix_bd987uo7pqus-0>li:before {
  content: "\\0025cf   "
}

.lst-kix_bd987uo7pqus-4>li:before {
  content: "\\0025cb   "
}

ul.lst-kix_1s8qgf4ntfy6-5 {
  list-style-type: none
}

ul.lst-kix_5cy47ievptas-5 {
  list-style-type: none
}

ul.lst-kix_2a03qcigu0f2-1 {
  list-style-type: none
}

ul.lst-kix_1s8qgf4ntfy6-4 {
  list-style-type: none
}

ul.lst-kix_5cy47ievptas-6 {
  list-style-type: none
}

ul.lst-kix_2a03qcigu0f2-0 {
  list-style-type: none
}

ul.lst-kix_1s8qgf4ntfy6-7 {
  list-style-type: none
}

ul.lst-kix_5cy47ievptas-7 {
  list-style-type: none
}

ul.lst-kix_1s8qgf4ntfy6-6 {
  list-style-type: none
}

ul.lst-kix_5cy47ievptas-8 {
  list-style-type: none
}

.lst-kix_i70phmy36es7-1>li:before {
  content: "" counter(lst-ctn-kix_i70phmy36es7-1, lower-latin) ". "
}

ul.lst-kix_1s8qgf4ntfy6-8 {
  list-style-type: none
}

.lst-kix_1mz2712tijq9-6>li:before {
  content: "\\0025cb   "
}

.lst-kix_5nqdbtxdbgr4-1>li:before {
  content: "\\0025cb   "
}

.lst-kix_i70phmy36es7-4>li {
  counter-increment: lst-ctn-kix_i70phmy36es7-4
}

ul.lst-kix_kjj132141nex-0 {
  list-style-type: none
}

.lst-kix_1mz2712tijq9-8>li:before {
  content: "\\0025cf   "
}

ul.lst-kix_kjj132141nex-2 {
  list-style-type: none
}

.lst-kix_5nqdbtxdbgr4-5>li:before {
  content: "\\0025a0   "
}

ul.lst-kix_kjj132141nex-1 {
  list-style-type: none
}

ul.lst-kix_kjj132141nex-4 {
  list-style-type: none
}

.lst-kix_2a03qcigu0f2-7>li:before {
  content: "\\0025cb   "
}

ul.lst-kix_kjj132141nex-3 {
  list-style-type: none
}

ul.lst-kix_kjj132141nex-6 {
  list-style-type: none
}

.lst-kix_5nqdbtxdbgr4-3>li:before {
  content: "\\0025cf   "
}

ul.lst-kix_kjj132141nex-5 {
  list-style-type: none
}

ul.lst-kix_kjj132141nex-8 {
  list-style-type: none
}

ul.lst-kix_kjj132141nex-7 {
  list-style-type: none
}

ul.lst-kix_2a03qcigu0f2-8 {
  list-style-type: none
}

.lst-kix_rtfebb3v4zx2-7>li {
  counter-increment: lst-ctn-kix_rtfebb3v4zx2-7
}

.lst-kix_1mz2712tijq9-4>li:before {
  content: "\\0025c6   "
}

.lst-kix_i70phmy36es7-3>li:before {
  content: "" counter(lst-ctn-kix_i70phmy36es7-3, decimal) ". "
}

.lst-kix_i70phmy36es7-5>li:before {
  content: "" counter(lst-ctn-kix_i70phmy36es7-5, lower-roman) ". "
}

.lst-kix_byj4xjdm9nqi-8>li:before {
  content: "\\0025a0   "
}

.lst-kix_1mz2712tijq9-0>li:before {
  content: "\\002794   "
}

.lst-kix_i70phmy36es7-7>li:before {
  content: "" counter(lst-ctn-kix_i70phmy36es7-7, lower-latin) ". "
}

.lst-kix_1mz2712tijq9-2>li:before {
  content: "\\0025cf   "
}

.lst-kix_i70phmy36es7-6>li {
  counter-increment: lst-ctn-kix_i70phmy36es7-6
}

ul.lst-kix_ks5ooyhkhmj-4 {
  list-style-type: none
}

ul.lst-kix_ks5ooyhkhmj-3 {
  list-style-type: none
}

ul.lst-kix_ks5ooyhkhmj-6 {
  list-style-type: none
}

ul.lst-kix_ks5ooyhkhmj-5 {
  list-style-type: none
}

ul.lst-kix_ks5ooyhkhmj-8 {
  list-style-type: none
}

ul.lst-kix_ks5ooyhkhmj-7 {
  list-style-type: none
}

.lst-kix_1s8qgf4ntfy6-8>li:before {
  content: "\\0025a0   "
}

ul.lst-kix_1mz2712tijq9-8 {
  list-style-type: none
}

.lst-kix_1s8qgf4ntfy6-2>li:before {
  content: "\\0025a0   "
}

.lst-kix_1s8qgf4ntfy6-6>li:before {
  content: "\\0025cf   "
}

.lst-kix_rtfebb3v4zx2-6>li:before {
  content: "" counter(lst-ctn-kix_rtfebb3v4zx2-6, decimal) ". "
}

.lst-kix_rtfebb3v4zx2-8>li:before {
  content: "" counter(lst-ctn-kix_rtfebb3v4zx2-8, lower-roman) ". "
}

.lst-kix_qthp0cfoiw80-4>li:before {
  content: "-  "
}

.lst-kix_rtfebb3v4zx2-8>li {
  counter-increment: lst-ctn-kix_rtfebb3v4zx2-8
}

.lst-kix_1s8qgf4ntfy6-4>li:before {
  content: "\\0025cb   "
}

.lst-kix_qthp0cfoiw80-6>li:before {
  content: "-  "
}

ul.lst-kix_1mz2712tijq9-6 {
  list-style-type: none
}

.lst-kix_lc6lbngtx2du-8>li:before {
  content: "\\0025a0   "
}

ul.lst-kix_1mz2712tijq9-7 {
  list-style-type: none
}

ul.lst-kix_1mz2712tijq9-4 {
  list-style-type: none
}

.lst-kix_2a03qcigu0f2-5>li:before {
  content: "\\0025a0   "
}

ul.lst-kix_1mz2712tijq9-5 {
  list-style-type: none
}

ul.lst-kix_1mz2712tijq9-2 {
  list-style-type: none
}

.lst-kix_qthp0cfoiw80-8>li:before {
  content: "-  "
}

.lst-kix_5nqdbtxdbgr4-7>li:before {
  content: "\\0025cb   "
}

ul.lst-kix_1mz2712tijq9-3 {
  list-style-type: none
}

.lst-kix_i70phmy36es7-5>li {
  counter-increment: lst-ctn-kix_i70phmy36es7-5
}

li.li-bullet-0:before {
  margin-left: -18pt;
  white-space: nowrap;
  display: inline-block;
  min-width: 18pt
}

ul.lst-kix_1mz2712tijq9-0 {
  list-style-type: none
}

.lst-kix_1s8qgf4ntfy6-0>li:before {
  content: "\\0025cf   "
}

ul.lst-kix_1mz2712tijq9-1 {
  list-style-type: none
}

ol.lst-kix_i70phmy36es7-0 {
  list-style-type: none
}

.lst-kix_4z4oebq2d6xw-0>li:before {
  content: "\\0025cf   "
}

ol.lst-kix_i70phmy36es7-2 {
  list-style-type: none
}

.lst-kix_2a03qcigu0f2-1>li:before {
  content: "\\0025cb   "
}

.lst-kix_2a03qcigu0f2-3>li:before {
  content: "\\0025cf   "
}

ol.lst-kix_i70phmy36es7-1 {
  list-style-type: none
}

ul.lst-kix_dxfyrqkomy19-0 {
  list-style-type: none
}

ol.lst-kix_i70phmy36es7-4 {
  list-style-type: none
}

.lst-kix_4z4oebq2d6xw-2>li:before {
  content: "\\0025a0   "
}

ol.lst-kix_i70phmy36es7-3 {
  list-style-type: none
}

ul.lst-kix_dxfyrqkomy19-2 {
  list-style-type: none
}

ol.lst-kix_i70phmy36es7-6 {
  list-style-type: none
}

ul.lst-kix_dxfyrqkomy19-1 {
  list-style-type: none
}

ol.lst-kix_i70phmy36es7-5 {
  list-style-type: none
}

.lst-kix_4z4oebq2d6xw-4>li:before {
  content: "\\0025cb   "
}

ol.lst-kix_i70phmy36es7-8.start {
  counter-reset: lst-ctn-kix_i70phmy36es7-8 0
}

ul.lst-kix_ks5ooyhkhmj-0 {
  list-style-type: none
}

ul.lst-kix_ks5ooyhkhmj-2 {
  list-style-type: none
}

ul.lst-kix_ks5ooyhkhmj-1 {
  list-style-type: none
}

ol {
  margin: 0;
  padding: 0
}

table td,
table th {
  padding: 0
}

.c9 {
  margin-left: 36pt;
  padding-top: 18pt;
  padding-left: 0pt;
  padding-bottom: 6pt;
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: justify
}

.c7 {
  margin-left: 36pt;
  padding-top: 18pt;
  padding-left: 0pt;
  padding-bottom: 6pt;
  line-height: 1.0;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: justify;
  color: white;
}

.c20 {
  margin-left: 36pt;
  padding-top: 0pt;
  text-indent: -18pt;
  padding-bottom: 0pt;
  line-height: 1.15;
  orphans: 2;
  widows: 2;
  text-align: center
}

.c17 {
  margin-left: 36pt;
  padding-top: 0pt;
  text-indent: -18pt;
  padding-bottom: 0pt;
  line-height: 1.15;
  orphans: 2;
  widows: 2;
  text-align: right
}

.c2 {
  margin-left: 36pt;
  padding-top: 0pt;
  padding-left: 0pt;
  padding-bottom: 0pt;
  line-height: 1.0;
  orphans: 2;
  widows: 2;
  text-align: justify
}

.c8 {
  padding-top: 0pt;
  padding-bottom: 3pt;
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: center
}

.c1 {
  color: white;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 24px;
  font-family: "Montserrat";
  font-style: normal
}

.c25 {
  -webkit-text-decoration-skip: none;
  color: #9900ff;
  font-weight: 700;
  text-decoration: underline;
  text-decoration-skip-ink: none;
  font-size: 20px;  font-family: "Montserrat"
}

.c4 {
  color: white;
  font-weight: 700;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 20px;  font-family: "Montserrat";
  font-style: normal
}

.c26 {
  padding-top: 20pt;
  padding-bottom: 6pt;
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: center
}

.c24 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1.15;
  orphans: 2;
  widows: 2;
  text-align: left
}

.c10 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1.15;
  orphans: 2;
  widows: 2;
  text-align: justify
}

.c3 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1.0;
  orphans: 2;
  widows: 2;
  text-align: justify
}

.c11 {
  color: white;
  text-decoration: none;
  vertical-align: baseline;
  font-style: normal
}

.c15 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1.0;
  text-align: left
}

.c18 {
  color: white;
  text-decoration: none;
  vertical-align: baseline;
  font-style: italic
}


.c6 {
  color: white;
  font-size: 24px;  font-family: "Montserrat";
  font-weight: 400
}

.c0 {
  color: white;
  font-size: 25px;
  font-family: "Montserrat";
  font-weight: 700
}

.c13 {
  font-weight: 400;
  font-size: 20px;  font-family: "Times New Roman"
}

.c19 {
  font-weight: 400;
  font-size: 22px;  font-family: "Arial"
}

.c22 {
  font-weight: 400;
  font-size: 17px;  font-family: "Arial"
}

.c16 {
  color: white;
  margin: 5px
}

.c14 {
  padding: 0;
  margin: 0
}

.c23 {
  margin-left: 72pt;
  padding-left: 0pt
}


.c5 {
  height: 11pt
}

.title {
  padding-top: 0pt;
  color: white;
  font-size: 22px;  padding-bottom: 3pt;
  font-family: "Arial";
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left
}

.subtitle {
  padding-top: 0pt;
  color: white;
  font-size: 18px;  padding-bottom: 16pt;
  font-family: "Arial";
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left
}

/*-------------------------------------------------------------------Privacy and more END------------------------------------------------------------*/`, "",{"version":3,"sources":["webpack://./src/css/footerSections.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;AACA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,yBAAyB;EACzB,2BAA2B;EAC3B,iCAAiC;;EAEjC;;gDAE8C;AAChD;AACA;EACE,mBAAmB;EACnB,+DAAuE;EACvE,mBAAmB;EACnB,kBAAkB;AACpB;AACA,kJAAkJ;AAClJ;EACE,aAAa;EACb,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,cAAc;AAChB;;;AAGA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,6BAA6B;EAC7B,WAAW;AACb;AACA;EACE,6BAA6B;EAC7B,WAAW;AACb;AACA;EACE,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,SAAS;EACT;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT;AACF;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,SAAS;EACT;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,SAAS;EACT;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT;AACF;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;EACxB,eAAe;EACf,yBAAyB;EACzB;AACF;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,8BAA8B;EAC9B,eAAe,GAAG;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;EACxB,eAAe,GAAG,yBAAyB;EAC3C;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,SAAS;EACT;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,SAAS;EACT;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT;AACF;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,wBAAwB;EACxB;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB;AACF;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,wBAAwB;EACxB;AACF;;;AAGA;EACE,YAAY;EACZ,eAAe,GAAG,yBAAyB;EAC3C;AACF;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe,GAAG;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe,GAAG;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe,GAAG;AACpB;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE,UAAU;EACV;AACF;;AAEA;EACE,iBAAiB;EACjB;AACF;;;AAGA;EACE;AACF;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe,GAAG,mBAAmB;EACrC,oBAAoB;EACpB,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT;AACF;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe,GAAG,oBAAoB;EACtC,oBAAoB;EACpB,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT;AACF;;AAEA,sJAAsJ","sourcesContent":["html {\n  scroll-behavior: smooth;\n}\nbody {\n  zoom: 65%;\n  width: 100%;\n  height: 100%;\n  font-family: poppins;\n  background-color: #171717;\n  background-position: center;\n  /* - Test - animated background */\n\n  /* background: linear-gradient(60deg, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a, #0e0e16, #0f0e1a);\n  background-size: 50% 20%;\n  animation: gradientMove 10s linear infinite; */\n}\n@font-face {\n  font-family: \"Nord\";\n  src: url(\"../../public/static/fonts/Nord-Light.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n/*-------------------------------------------------------------------Privacy and more------------------------------------------------------------*/\n#hyperlink-container {\n  display: flex;\n  justify-content: center;\n  margin: 0px 20px 100px 20px;\n}\n\n.hyperlink {\n  margin: 0 50px;\n  text-decoration: none;\n  color: #757575;\n  font-size: 110%;\n  font-family: 'Nord';\n  font-style: normal;\n}\n\n#links-row {\n  display: flex;\n  justify-content: space-between;\n}\n.link-content.active {\n  display: block;\n}\n\n\n.link-content-titles{\n  font-family: 'Nord';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 300%;\n  margin-bottom: 100px;\n  color: white;\n}\n#privacy-notice {\n  margin: 200px auto 300px auto;\n  width: 90vw;\n}\n#delivery-information {\n  margin: 200px auto 300px auto;\n  width: 90vw;\n}\n#terms-of-service {\n  margin: 200px auto 300px auto;\n  width: 90vw;\n}\n\n.lst-kix_4z4oebq2d6xw-8>li:before {\n  content: \"\\0025a0   \"\n}\n\n.lst-kix_4z4oebq2d6xw-7>li:before {\n  content: \"\\0025cb   \"\n}\n\n.lst-kix_4z4oebq2d6xw-6>li:before {\n  content: \"\\0025cf   \"\n}\n\nul.lst-kix_bd987uo7pqus-0 {\n  list-style-type: none\n}\n\nul.lst-kix_bd987uo7pqus-1 {\n  list-style-type: none\n}\n\nul.lst-kix_bd987uo7pqus-2 {\n  list-style-type: none\n}\n\nul.lst-kix_dxfyrqkomy19-4 {\n  list-style-type: none\n}\n\nol.lst-kix_i70phmy36es7-8 {\n  list-style-type: none\n}\n\nul.lst-kix_bd987uo7pqus-3 {\n  list-style-type: none\n}\n\nul.lst-kix_dxfyrqkomy19-3 {\n  list-style-type: none\n}\n\nol.lst-kix_i70phmy36es7-7 {\n  list-style-type: none\n}\n\nul.lst-kix_bd987uo7pqus-4 {\n  list-style-type: none\n}\n\nul.lst-kix_dxfyrqkomy19-6 {\n  list-style-type: none\n}\n\nul.lst-kix_bd987uo7pqus-5 {\n  list-style-type: none\n}\n\nul.lst-kix_dxfyrqkomy19-5 {\n  list-style-type: none\n}\n\nul.lst-kix_bd987uo7pqus-6 {\n  list-style-type: none\n}\n\nul.lst-kix_dxfyrqkomy19-8 {\n  list-style-type: none\n}\n\nul.lst-kix_bd987uo7pqus-7 {\n  list-style-type: none\n}\n\nul.lst-kix_dxfyrqkomy19-7 {\n  list-style-type: none\n}\n\nul.lst-kix_bd987uo7pqus-8 {\n  list-style-type: none\n}\n\nul.lst-kix_k1hodgudwc6-8 {\n  list-style-type: none\n}\n\nul.lst-kix_k1hodgudwc6-7 {\n  list-style-type: none\n}\n\nul.lst-kix_k1hodgudwc6-6 {\n  list-style-type: none\n}\n\nol.lst-kix_i70phmy36es7-1.start {\n  counter-reset: lst-ctn-kix_i70phmy36es7-1 0\n}\n\nol.lst-kix_i70phmy36es7-7.start {\n  counter-reset: lst-ctn-kix_i70phmy36es7-7 0\n}\n\nul.lst-kix_k1hodgudwc6-1 {\n  list-style-type: none\n}\n\nul.lst-kix_k1hodgudwc6-0 {\n  list-style-type: none\n}\n\nul.lst-kix_k1hodgudwc6-5 {\n  list-style-type: none\n}\n\nul.lst-kix_k1hodgudwc6-4 {\n  list-style-type: none\n}\n\nul.lst-kix_k1hodgudwc6-3 {\n  list-style-type: none\n}\n\nol.lst-kix_rtfebb3v4zx2-2.start {\n  counter-reset: lst-ctn-kix_rtfebb3v4zx2-2 0\n}\n\nul.lst-kix_k1hodgudwc6-2 {\n  list-style-type: none\n}\n\n.lst-kix_rtfebb3v4zx2-3>li:before {\n  content: \"\" counter(lst-ctn-kix_rtfebb3v4zx2-3, decimal) \". \"\n}\n\n.lst-kix_rtfebb3v4zx2-2>li:before {\n  content: \"\" counter(lst-ctn-kix_rtfebb3v4zx2-2, lower-roman) \". \"\n}\n\n.lst-kix_rtfebb3v4zx2-4>li:before {\n  content: \"\" counter(lst-ctn-kix_rtfebb3v4zx2-4, lower-latin) \". \"\n}\n\n.lst-kix_rtfebb3v4zx2-1>li:before {\n  content: \"\" counter(lst-ctn-kix_rtfebb3v4zx2-1, lower-latin) \". \"\n}\n\n.lst-kix_rtfebb3v4zx2-5>li:before {\n  content: \"\" counter(lst-ctn-kix_rtfebb3v4zx2-5, lower-roman) \". \"\n}\n\n.lst-kix_rtfebb3v4zx2-2>li {\n  counter-increment: lst-ctn-kix_rtfebb3v4zx2-2\n}\n\n.lst-kix_5cy47ievptas-0>li:before {\n  content: \"\\0025cf   \"\n}\n\nol.lst-kix_rtfebb3v4zx2-8.start {\n  counter-reset: lst-ctn-kix_rtfebb3v4zx2-8 0\n}\n\n.lst-kix_5cy47ievptas-1>li:before {\n  content: \"\\0025cb   \"\n}\n\n.lst-kix_5cy47ievptas-3>li:before {\n  content: \"\\0025cf   \"\n}\n\n.lst-kix_5cy47ievptas-2>li:before {\n  content: \"\\0025a0   \"\n}\n\nul.lst-kix_5nqdbtxdbgr4-8 {\n  list-style-type: none\n}\n\nul.lst-kix_5nqdbtxdbgr4-6 {\n  list-style-type: none\n}\n\nul.lst-kix_5nqdbtxdbgr4-7 {\n  list-style-type: none\n}\n\n.lst-kix_rtfebb3v4zx2-0>li:before {\n  content: \"\" counter(lst-ctn-kix_rtfebb3v4zx2-0, decimal) \". \"\n}\n\nul.lst-kix_5nqdbtxdbgr4-4 {\n  list-style-type: none\n}\n\nul.lst-kix_5nqdbtxdbgr4-5 {\n  list-style-type: none\n}\n\nul.lst-kix_5nqdbtxdbgr4-2 {\n  list-style-type: none\n}\n\nul.lst-kix_5nqdbtxdbgr4-3 {\n  list-style-type: none\n}\n\nul.lst-kix_5nqdbtxdbgr4-0 {\n  list-style-type: none\n}\n\nul.lst-kix_5nqdbtxdbgr4-1 {\n  list-style-type: none\n}\n\n.lst-kix_i70phmy36es7-0>li {\n  counter-increment: lst-ctn-kix_i70phmy36es7-0\n}\n\nol.lst-kix_i70phmy36es7-6.start {\n  counter-reset: lst-ctn-kix_i70phmy36es7-6 0\n}\n\n.lst-kix_wwac6hxnt0l-6>li:before {\n  content: \"\\0025cf   \"\n}\n\n.lst-kix_i70phmy36es7-7>li {\n  counter-increment: lst-ctn-kix_i70phmy36es7-7\n}\n\nol.lst-kix_rtfebb3v4zx2-7.start {\n  counter-reset: lst-ctn-kix_rtfebb3v4zx2-7 0\n}\n\n.lst-kix_5cy47ievptas-5>li:before {\n  content: \"\\0025a0   \"\n}\n\n.lst-kix_5cy47ievptas-7>li:before {\n  content: \"\\0025cb   \"\n}\n\n.lst-kix_wwac6hxnt0l-4>li:before {\n  content: \"\\0025cb   \"\n}\n\n.lst-kix_wwac6hxnt0l-8>li:before {\n  content: \"\\0025a0   \"\n}\n\n.lst-kix_wwac6hxnt0l-5>li:before {\n  content: \"\\0025a0   \"\n}\n\n.lst-kix_5cy47ievptas-4>li:before {\n  content: \"\\0025cb   \"\n}\n\n.lst-kix_5cy47ievptas-8>li:before {\n  content: \"\\0025a0   \"\n}\n\n.lst-kix_wwac6hxnt0l-7>li:before {\n  content: \"\\0025cb   \"\n}\n\n.lst-kix_5cy47ievptas-6>li:before {\n  content: \"\\0025cf   \"\n}\n\n.lst-kix_wwac6hxnt0l-0>li:before {\n  content: \"\\0025cf   \"\n}\n\n.lst-kix_wwac6hxnt0l-1>li:before {\n  content: \"\\0025cb   \"\n}\n\n.lst-kix_rf5ciq3y790d-8>li:before {\n  content: \"-  \"\n}\n\n.lst-kix_wwac6hxnt0l-2>li:before {\n  content: \"\\0025a0   \"\n}\n\n.lst-kix_rf5ciq3y790d-5>li:before {\n  content: \"-  \"\n}\n\n.lst-kix_rf5ciq3y790d-7>li:before {\n  content: \"-  \"\n}\n\n.lst-kix_wwac6hxnt0l-3>li:before {\n  content: \"\\0025cf   \"\n}\n\n.lst-kix_rf5ciq3y790d-6>li:before {\n  content: \"-  \"\n}\n\n.lst-kix_rf5ciq3y790d-1>li:before {\n  content: \"-  \"\n}\n\n.lst-kix_rf5ciq3y790d-3>li:before {\n  content: \"-  \"\n}\n\n.lst-kix_rf5ciq3y790d-0>li:before {\n  content: \"-  \"\n}\n\n.lst-kix_rf5ciq3y790d-4>li:before {\n  content: \"-  \"\n}\n\n.lst-kix_rtfebb3v4zx2-0>li {\n  counter-increment: lst-ctn-kix_rtfebb3v4zx2-0\n}\n\n.lst-kix_rf5ciq3y790d-2>li:before {\n  content: \"-  \"\n}\n\n.lst-kix_bd987uo7pqus-1>li:before {\n  content: \"\\0025cb   \"\n}\n\n.lst-kix_rtfebb3v4zx2-6>li {\n  counter-increment: lst-ctn-kix_rtfebb3v4zx2-6\n}\n\n.lst-kix_bd987uo7pqus-3>li:before {\n  content: \"\\0025cf   \"\n}\n\nul.lst-kix_pqfk9eb5xg9l-0 {\n  list-style-type: none\n}\n\n.lst-kix_i70phmy36es7-0>li:before {\n  content: \"\" counter(lst-ctn-kix_i70phmy36es7-0, decimal) \". \"\n}\n\nul.lst-kix_pqfk9eb5xg9l-1 {\n  list-style-type: none\n}\n\nul.lst-kix_pqfk9eb5xg9l-2 {\n  list-style-type: none\n}\n\nul.lst-kix_pqfk9eb5xg9l-3 {\n  list-style-type: none\n}\n\nul.lst-kix_pqfk9eb5xg9l-4 {\n  list-style-type: none\n}\n\nul.lst-kix_pqfk9eb5xg9l-5 {\n  list-style-type: none\n}\n\n.lst-kix_i70phmy36es7-2>li:before {\n  content: \"\" counter(lst-ctn-kix_i70phmy36es7-2, lower-roman) \". \"\n}\n\nul.lst-kix_pqfk9eb5xg9l-6 {\n  list-style-type: none\n}\n\nul.lst-kix_pqfk9eb5xg9l-7 {\n  list-style-type: none\n}\n\n.lst-kix_5nqdbtxdbgr4-0>li:before {\n  content: \"\\0025cf   \"\n}\n\nul.lst-kix_pqfk9eb5xg9l-8 {\n  list-style-type: none\n}\n\n.lst-kix_1mz2712tijq9-7>li:before {\n  content: \"\\0025c6   \"\n}\n\n.lst-kix_5nqdbtxdbgr4-2>li:before {\n  content: \"\\0025a0   \"\n}\n\n.lst-kix_2a03qcigu0f2-8>li:before {\n  content: \"\\0025a0   \"\n}\n\n.lst-kix_5nqdbtxdbgr4-4>li:before {\n  content: \"\\0025cb   \"\n}\n\n.lst-kix_rtfebb3v4zx2-5>li {\n  counter-increment: lst-ctn-kix_rtfebb3v4zx2-5\n}\n\n.lst-kix_i70phmy36es7-8>li:before {\n  content: \"\" counter(lst-ctn-kix_i70phmy36es7-8, lower-roman) \". \"\n}\n\n.lst-kix_i70phmy36es7-4>li:before {\n  content: \"\" counter(lst-ctn-kix_i70phmy36es7-4, lower-latin) \". \"\n}\n\n.lst-kix_1mz2712tijq9-5>li:before {\n  content: \"\\0025cf   \"\n}\n\n.lst-kix_byj4xjdm9nqi-7>li:before {\n  content: \"\\0025cb   \"\n}\n\n.lst-kix_1mz2712tijq9-3>li:before {\n  content: \"\\0025cb   \"\n}\n\nol.lst-kix_rtfebb3v4zx2-1.start {\n  counter-reset: lst-ctn-kix_rtfebb3v4zx2-1 0\n}\n\nol.lst-kix_rtfebb3v4zx2-4 {\n  list-style-type: none\n}\n\n.lst-kix_1mz2712tijq9-1>li:before {\n  content: \"\\0025c6   \"\n}\n\nol.lst-kix_rtfebb3v4zx2-3 {\n  list-style-type: none\n}\n\n.lst-kix_i70phmy36es7-3>li {\n  counter-increment: lst-ctn-kix_i70phmy36es7-3\n}\n\nol.lst-kix_rtfebb3v4zx2-6 {\n  list-style-type: none\n}\n\nol.lst-kix_i70phmy36es7-0.start {\n  counter-reset: lst-ctn-kix_i70phmy36es7-0 0\n}\n\nol.lst-kix_i70phmy36es7-3.start {\n  counter-reset: lst-ctn-kix_i70phmy36es7-3 0\n}\n\nol.lst-kix_rtfebb3v4zx2-5 {\n  list-style-type: none\n}\n\nol.lst-kix_rtfebb3v4zx2-8 {\n  list-style-type: none\n}\n\n.lst-kix_i70phmy36es7-6>li:before {\n  content: \"\" counter(lst-ctn-kix_i70phmy36es7-6, decimal) \". \"\n}\n\nol.lst-kix_rtfebb3v4zx2-7 {\n  list-style-type: none\n}\n\nol.lst-kix_rtfebb3v4zx2-0 {\n  list-style-type: none\n}\n\nol.lst-kix_rtfebb3v4zx2-2 {\n  list-style-type: none\n}\n\nol.lst-kix_rtfebb3v4zx2-1 {\n  list-style-type: none\n}\n\n.lst-kix_1s8qgf4ntfy6-7>li:before {\n  content: \"\\0025cb   \"\n}\n\nol.lst-kix_i70phmy36es7-2.start {\n  counter-reset: lst-ctn-kix_i70phmy36es7-2 0\n}\n\nol.lst-kix_rtfebb3v4zx2-4.start {\n  counter-reset: lst-ctn-kix_rtfebb3v4zx2-4 0\n}\n\n.lst-kix_1s8qgf4ntfy6-3>li:before {\n  content: \"\\0025cf   \"\n}\n\n.lst-kix_rtfebb3v4zx2-4>li {\n  counter-increment: lst-ctn-kix_rtfebb3v4zx2-4\n}\n\n.lst-kix_1s8qgf4ntfy6-1>li:before {\n  content: \"\\0025cb   \"\n}\n\n.lst-kix_1s8qgf4ntfy6-5>li:before {\n  content: \"\\0025a0   \"\n}\n\n.lst-kix_rtfebb3v4zx2-7>li:before {\n  content: \"\" counter(lst-ctn-kix_rtfebb3v4zx2-7, lower-latin) \". \"\n}\n\n.lst-kix_qthp0cfoiw80-3>li:before {\n  content: \"-  \"\n}\n\n.lst-kix_qthp0cfoiw80-5>li:before {\n  content: \"-  \"\n}\n\n.lst-kix_qthp0cfoiw80-7>li:before {\n  content: \"-  \"\n}\n\nol.lst-kix_rtfebb3v4zx2-3.start {\n  counter-reset: lst-ctn-kix_rtfebb3v4zx2-3 0\n}\n\n.lst-kix_5nqdbtxdbgr4-6>li:before {\n  content: \"\\0025cf   \"\n}\n\n.lst-kix_i70phmy36es7-8>li {\n  counter-increment: lst-ctn-kix_i70phmy36es7-8\n}\n\n.lst-kix_2a03qcigu0f2-6>li:before {\n  content: \"\\0025cf   \"\n}\n\n.lst-kix_2a03qcigu0f2-4>li:before {\n  content: \"\\0025cb   \"\n}\n\n.lst-kix_i70phmy36es7-2>li {\n  counter-increment: lst-ctn-kix_i70phmy36es7-2\n}\n\n.lst-kix_5nqdbtxdbgr4-8>li:before {\n  content: \"\\0025a0   \"\n}\n\n.lst-kix_2a03qcigu0f2-2>li:before {\n  content: \"\\0025a0   \"\n}\n\n.lst-kix_4z4oebq2d6xw-1>li:before {\n  content: \"\\0025cb   \"\n}\n\n.lst-kix_4z4oebq2d6xw-3>li:before {\n  content: \"\\0025cf   \"\n}\n\n.lst-kix_4z4oebq2d6xw-5>li:before {\n  content: \"\\0025a0   \"\n}\n\n.lst-kix_2a03qcigu0f2-0>li:before {\n  content: \"\\0025cf   \"\n}\n\nul.lst-kix_rf5ciq3y790d-3 {\n  list-style-type: none\n}\n\n.lst-kix_kjj132141nex-4>li:before {\n  content: \"\\0025cb   \"\n}\n\nul.lst-kix_lc6lbngtx2du-7 {\n  list-style-type: none\n}\n\nul.lst-kix_rf5ciq3y790d-4 {\n  list-style-type: none\n}\n\nol.lst-kix_i70phmy36es7-4.start {\n  counter-reset: lst-ctn-kix_i70phmy36es7-4 0\n}\n\nul.lst-kix_lc6lbngtx2du-6 {\n  list-style-type: none\n}\n\nul.lst-kix_rf5ciq3y790d-5 {\n  list-style-type: none\n}\n\n.lst-kix_kjj132141nex-3>li:before {\n  content: \"\\0025cf   \"\n}\n\n.lst-kix_kjj132141nex-5>li:before {\n  content: \"\\0025a0   \"\n}\n\nul.lst-kix_lc6lbngtx2du-5 {\n  list-style-type: none\n}\n\nul.lst-kix_rf5ciq3y790d-6 {\n  list-style-type: none\n}\n\nul.lst-kix_lc6lbngtx2du-4 {\n  list-style-type: none\n}\n\nul.lst-kix_rf5ciq3y790d-7 {\n  list-style-type: none\n}\n\nul.lst-kix_lc6lbngtx2du-3 {\n  list-style-type: none\n}\n\nul.lst-kix_rf5ciq3y790d-8 {\n  list-style-type: none\n}\n\nul.lst-kix_lc6lbngtx2du-2 {\n  list-style-type: none\n}\n\nul.lst-kix_lc6lbngtx2du-1 {\n  list-style-type: none\n}\n\nul.lst-kix_lc6lbngtx2du-0 {\n  list-style-type: none\n}\n\n.lst-kix_kjj132141nex-0>li:before {\n  content: \"\\0025cf   \"\n}\n\n.lst-kix_kjj132141nex-8>li:before {\n  content: \"\\0025a0   \"\n}\n\n.lst-kix_lc6lbngtx2du-0>li:before {\n  content: \"\\0025cf   \"\n}\n\n.lst-kix_kjj132141nex-1>li:before {\n  content: \"\\0025cb   \"\n}\n\n.lst-kix_pqfk9eb5xg9l-0>li:before {\n  content: \"\\0025cf   \"\n}\n\n.lst-kix_kjj132141nex-2>li:before {\n  content: \"\\0025a0   \"\n}\n\n.lst-kix_lc6lbngtx2du-2>li:before {\n  content: \"\\0025a0   \"\n}\n\nul.lst-kix_rf5ciq3y790d-0 {\n  list-style-type: none\n}\n\nul.lst-kix_rf5ciq3y790d-1 {\n  list-style-type: none\n}\n\n.lst-kix_lc6lbngtx2du-1>li:before {\n  content: \"\\0025cb   \"\n}\n\nul.lst-kix_rf5ciq3y790d-2 {\n  list-style-type: none\n}\n\nul.lst-kix_lc6lbngtx2du-8 {\n  list-style-type: none\n}\n\n.lst-kix_lc6lbngtx2du-4>li:before {\n  content: \"\\0025cb   \"\n}\n\n.lst-kix_dxfyrqkomy19-1>li:before {\n  content: \"\\0025cb   \"\n}\n\n.lst-kix_dxfyrqkomy19-0>li:before {\n  content: \"\\0025cf   \"\n}\n\n.lst-kix_rtfebb3v4zx2-1>li {\n  counter-increment: lst-ctn-kix_rtfebb3v4zx2-1\n}\n\n.lst-kix_lc6lbngtx2du-3>li:before {\n  content: \"\\0025cf   \"\n}\n\n.lst-kix_lc6lbngtx2du-7>li:before {\n  content: \"\\0025cb   \"\n}\n\n.lst-kix_kjj132141nex-7>li:before {\n  content: \"\\0025cb   \"\n}\n\n.lst-kix_kjj132141nex-6>li:before {\n  content: \"\\0025cf   \"\n}\n\n.lst-kix_lc6lbngtx2du-6>li:before {\n  content: \"\\0025cf   \"\n}\n\n.lst-kix_lc6lbngtx2du-5>li:before {\n  content: \"\\0025a0   \"\n}\n\n.lst-kix_dxfyrqkomy19-8>li:before {\n  content: \"\\0025a0   \"\n}\n\nul.lst-kix_wwac6hxnt0l-0 {\n  list-style-type: none\n}\n\nul.lst-kix_wwac6hxnt0l-1 {\n  list-style-type: none\n}\n\nul.lst-kix_wwac6hxnt0l-2 {\n  list-style-type: none\n}\n\n.lst-kix_qthp0cfoiw80-2>li:before {\n  content: \"-  \"\n}\n\nol.lst-kix_rtfebb3v4zx2-5.start {\n  counter-reset: lst-ctn-kix_rtfebb3v4zx2-5 0\n}\n\n.lst-kix_qthp0cfoiw80-1>li:before {\n  content: \"-  \"\n}\n\n.lst-kix_pqfk9eb5xg9l-8>li:before {\n  content: \"\\0025a0   \"\n}\n\n.lst-kix_qthp0cfoiw80-0>li:before {\n  content: \"-  \"\n}\n\n.lst-kix_pqfk9eb5xg9l-7>li:before {\n  content: \"\\0025cb   \"\n}\n\n.lst-kix_dxfyrqkomy19-2>li:before {\n  content: \"\\0025a0   \"\n}\n\n.lst-kix_pqfk9eb5xg9l-5>li:before {\n  content: \"\\0025a0   \"\n}\n\n.lst-kix_dxfyrqkomy19-3>li:before {\n  content: \"\\0025cf   \"\n}\n\n.lst-kix_pqfk9eb5xg9l-4>li:before {\n  content: \"\\0025cb   \"\n}\n\n.lst-kix_pqfk9eb5xg9l-6>li:before {\n  content: \"\\0025cf   \"\n}\n\n.lst-kix_dxfyrqkomy19-4>li:before {\n  content: \"\\0025cb   \"\n}\n\n.lst-kix_k1hodgudwc6-8>li:before {\n  content: \"\\0025a0   \"\n}\n\n.lst-kix_dxfyrqkomy19-6>li:before {\n  content: \"\\0025cf   \"\n}\n\nul.lst-kix_wwac6hxnt0l-3 {\n  list-style-type: none\n}\n\n.lst-kix_pqfk9eb5xg9l-1>li:before {\n  content: \"\\0025cb   \"\n}\n\n.lst-kix_k1hodgudwc6-6>li:before {\n  content: \"\\0025cf   \"\n}\n\n.lst-kix_k1hodgudwc6-7>li:before {\n  content: \"\\0025cb   \"\n}\n\nul.lst-kix_wwac6hxnt0l-4 {\n  list-style-type: none\n}\n\n.lst-kix_dxfyrqkomy19-5>li:before {\n  content: \"\\0025a0   \"\n}\n\n.lst-kix_dxfyrqkomy19-7>li:before {\n  content: \"\\0025cb   \"\n}\n\nul.lst-kix_wwac6hxnt0l-5 {\n  list-style-type: none\n}\n\n.lst-kix_pqfk9eb5xg9l-2>li:before {\n  content: \"\\0025a0   \"\n}\n\nul.lst-kix_wwac6hxnt0l-6 {\n  list-style-type: none\n}\n\nul.lst-kix_wwac6hxnt0l-7 {\n  list-style-type: none\n}\n\n.lst-kix_pqfk9eb5xg9l-3>li:before {\n  content: \"\\0025cf   \"\n}\n\nul.lst-kix_wwac6hxnt0l-8 {\n  list-style-type: none\n}\n\n.lst-kix_k1hodgudwc6-2>li:before {\n  content: \"\\0025a0   \"\n}\n\n.lst-kix_k1hodgudwc6-3>li:before {\n  content: \"\\0025cf   \"\n}\n\n.lst-kix_ks5ooyhkhmj-7>li:before {\n  content: \"\\0025cb   \"\n}\n\n.lst-kix_k1hodgudwc6-0>li:before {\n  content: \"\\0025cf   \"\n}\n\n.lst-kix_k1hodgudwc6-1>li:before {\n  content: \"\\0025cb   \"\n}\n\n.lst-kix_k1hodgudwc6-4>li:before {\n  content: \"\\0025cb   \"\n}\n\n.lst-kix_k1hodgudwc6-5>li:before {\n  content: \"\\0025a0   \"\n}\n\n.lst-kix_ks5ooyhkhmj-6>li:before {\n  content: \"\\0025cf   \"\n}\n\n.lst-kix_byj4xjdm9nqi-6>li:before {\n  content: \"\\0025cf   \"\n}\n\n.lst-kix_ks5ooyhkhmj-8>li:before {\n  content: \"\\0025a0   \"\n}\n\n.lst-kix_byj4xjdm9nqi-5>li:before {\n  content: \"\\0025a0   \"\n}\n\n.lst-kix_byj4xjdm9nqi-4>li:before {\n  content: \"\\0025cb   \"\n}\n\n.lst-kix_byj4xjdm9nqi-1>li:before {\n  content: \"\\0025cb   \"\n}\n\n.lst-kix_byj4xjdm9nqi-3>li:before {\n  content: \"\\0025cf   \"\n}\n\n.lst-kix_i70phmy36es7-1>li {\n  counter-increment: lst-ctn-kix_i70phmy36es7-1\n}\n\n.lst-kix_byj4xjdm9nqi-2>li:before {\n  content: \"\\0025a0   \"\n}\n\nol.lst-kix_i70phmy36es7-5.start {\n  counter-reset: lst-ctn-kix_i70phmy36es7-5 0\n}\n\n.lst-kix_byj4xjdm9nqi-0>li:before {\n  content: \"\\0025cf   \"\n}\n\nul.lst-kix_qthp0cfoiw80-6 {\n  list-style-type: none\n}\n\nul.lst-kix_4z4oebq2d6xw-4 {\n  list-style-type: none\n}\n\nul.lst-kix_qthp0cfoiw80-7 {\n  list-style-type: none\n}\n\nul.lst-kix_4z4oebq2d6xw-3 {\n  list-style-type: none\n}\n\nul.lst-kix_qthp0cfoiw80-4 {\n  list-style-type: none\n}\n\nul.lst-kix_4z4oebq2d6xw-2 {\n  list-style-type: none\n}\n\nul.lst-kix_qthp0cfoiw80-5 {\n  list-style-type: none\n}\n\nul.lst-kix_4z4oebq2d6xw-1 {\n  list-style-type: none\n}\n\nul.lst-kix_4z4oebq2d6xw-8 {\n  list-style-type: none\n}\n\nul.lst-kix_4z4oebq2d6xw-7 {\n  list-style-type: none\n}\n\nul.lst-kix_qthp0cfoiw80-8 {\n  list-style-type: none\n}\n\nol.lst-kix_rtfebb3v4zx2-0.start {\n  counter-reset: lst-ctn-kix_rtfebb3v4zx2-0 0\n}\n\nul.lst-kix_4z4oebq2d6xw-6 {\n  list-style-type: none\n}\n\nul.lst-kix_byj4xjdm9nqi-8 {\n  list-style-type: none\n}\n\nul.lst-kix_4z4oebq2d6xw-5 {\n  list-style-type: none\n}\n\n.lst-kix_ks5ooyhkhmj-0>li:before {\n  content: \"\\0025cf   \"\n}\n\nul.lst-kix_byj4xjdm9nqi-7 {\n  list-style-type: none\n}\n\nul.lst-kix_byj4xjdm9nqi-6 {\n  list-style-type: none\n}\n\nol.lst-kix_rtfebb3v4zx2-6.start {\n  counter-reset: lst-ctn-kix_rtfebb3v4zx2-6 0\n}\n\nul.lst-kix_byj4xjdm9nqi-5 {\n  list-style-type: none\n}\n\nul.lst-kix_byj4xjdm9nqi-4 {\n  list-style-type: none\n}\n\n.lst-kix_ks5ooyhkhmj-1>li:before {\n  content: \"\\0025cb   \"\n}\n\nul.lst-kix_qthp0cfoiw80-2 {\n  list-style-type: none\n}\n\nul.lst-kix_byj4xjdm9nqi-3 {\n  list-style-type: none\n}\n\nul.lst-kix_4z4oebq2d6xw-0 {\n  list-style-type: none\n}\n\nul.lst-kix_qthp0cfoiw80-3 {\n  list-style-type: none\n}\n\nul.lst-kix_byj4xjdm9nqi-2 {\n  list-style-type: none\n}\n\n.lst-kix_bd987uo7pqus-7>li:before {\n  content: \"\\0025cb   \"\n}\n\n.lst-kix_bd987uo7pqus-8>li:before {\n  content: \"\\0025a0   \"\n}\n\nul.lst-kix_qthp0cfoiw80-0 {\n  list-style-type: none\n}\n\nul.lst-kix_byj4xjdm9nqi-1 {\n  list-style-type: none\n}\n\nul.lst-kix_qthp0cfoiw80-1 {\n  list-style-type: none\n}\n\nul.lst-kix_byj4xjdm9nqi-0 {\n  list-style-type: none\n}\n\n.lst-kix_ks5ooyhkhmj-2>li:before {\n  content: \"\\0025a0   \"\n}\n\n.lst-kix_rtfebb3v4zx2-3>li {\n  counter-increment: lst-ctn-kix_rtfebb3v4zx2-3\n}\n\n.lst-kix_bd987uo7pqus-5>li:before {\n  content: \"\\0025a0   \"\n}\n\n.lst-kix_bd987uo7pqus-6>li:before {\n  content: \"\\0025cf   \"\n}\n\n.lst-kix_ks5ooyhkhmj-3>li:before {\n  content: \"\\0025cf   \"\n}\n\n.lst-kix_ks5ooyhkhmj-5>li:before {\n  content: \"\\0025a0   \"\n}\n\n.lst-kix_ks5ooyhkhmj-4>li:before {\n  content: \"\\0025cb   \"\n}\n\nul.lst-kix_2a03qcigu0f2-7 {\n  list-style-type: none\n}\n\nul.lst-kix_5cy47ievptas-0 {\n  list-style-type: none\n}\n\nul.lst-kix_2a03qcigu0f2-6 {\n  list-style-type: none\n}\n\n.lst-kix_bd987uo7pqus-2>li:before {\n  content: \"\\0025a0   \"\n}\n\nul.lst-kix_1s8qgf4ntfy6-1 {\n  list-style-type: none\n}\n\nul.lst-kix_5cy47ievptas-1 {\n  list-style-type: none\n}\n\nul.lst-kix_2a03qcigu0f2-5 {\n  list-style-type: none\n}\n\nul.lst-kix_1s8qgf4ntfy6-0 {\n  list-style-type: none\n}\n\nul.lst-kix_5cy47ievptas-2 {\n  list-style-type: none\n}\n\nul.lst-kix_2a03qcigu0f2-4 {\n  list-style-type: none\n}\n\nul.lst-kix_1s8qgf4ntfy6-3 {\n  list-style-type: none\n}\n\nul.lst-kix_5cy47ievptas-3 {\n  list-style-type: none\n}\n\nul.lst-kix_2a03qcigu0f2-3 {\n  list-style-type: none\n}\n\nul.lst-kix_1s8qgf4ntfy6-2 {\n  list-style-type: none\n}\n\nul.lst-kix_5cy47ievptas-4 {\n  list-style-type: none\n}\n\nul.lst-kix_2a03qcigu0f2-2 {\n  list-style-type: none\n}\n\n.lst-kix_bd987uo7pqus-0>li:before {\n  content: \"\\0025cf   \"\n}\n\n.lst-kix_bd987uo7pqus-4>li:before {\n  content: \"\\0025cb   \"\n}\n\nul.lst-kix_1s8qgf4ntfy6-5 {\n  list-style-type: none\n}\n\nul.lst-kix_5cy47ievptas-5 {\n  list-style-type: none\n}\n\nul.lst-kix_2a03qcigu0f2-1 {\n  list-style-type: none\n}\n\nul.lst-kix_1s8qgf4ntfy6-4 {\n  list-style-type: none\n}\n\nul.lst-kix_5cy47ievptas-6 {\n  list-style-type: none\n}\n\nul.lst-kix_2a03qcigu0f2-0 {\n  list-style-type: none\n}\n\nul.lst-kix_1s8qgf4ntfy6-7 {\n  list-style-type: none\n}\n\nul.lst-kix_5cy47ievptas-7 {\n  list-style-type: none\n}\n\nul.lst-kix_1s8qgf4ntfy6-6 {\n  list-style-type: none\n}\n\nul.lst-kix_5cy47ievptas-8 {\n  list-style-type: none\n}\n\n.lst-kix_i70phmy36es7-1>li:before {\n  content: \"\" counter(lst-ctn-kix_i70phmy36es7-1, lower-latin) \". \"\n}\n\nul.lst-kix_1s8qgf4ntfy6-8 {\n  list-style-type: none\n}\n\n.lst-kix_1mz2712tijq9-6>li:before {\n  content: \"\\0025cb   \"\n}\n\n.lst-kix_5nqdbtxdbgr4-1>li:before {\n  content: \"\\0025cb   \"\n}\n\n.lst-kix_i70phmy36es7-4>li {\n  counter-increment: lst-ctn-kix_i70phmy36es7-4\n}\n\nul.lst-kix_kjj132141nex-0 {\n  list-style-type: none\n}\n\n.lst-kix_1mz2712tijq9-8>li:before {\n  content: \"\\0025cf   \"\n}\n\nul.lst-kix_kjj132141nex-2 {\n  list-style-type: none\n}\n\n.lst-kix_5nqdbtxdbgr4-5>li:before {\n  content: \"\\0025a0   \"\n}\n\nul.lst-kix_kjj132141nex-1 {\n  list-style-type: none\n}\n\nul.lst-kix_kjj132141nex-4 {\n  list-style-type: none\n}\n\n.lst-kix_2a03qcigu0f2-7>li:before {\n  content: \"\\0025cb   \"\n}\n\nul.lst-kix_kjj132141nex-3 {\n  list-style-type: none\n}\n\nul.lst-kix_kjj132141nex-6 {\n  list-style-type: none\n}\n\n.lst-kix_5nqdbtxdbgr4-3>li:before {\n  content: \"\\0025cf   \"\n}\n\nul.lst-kix_kjj132141nex-5 {\n  list-style-type: none\n}\n\nul.lst-kix_kjj132141nex-8 {\n  list-style-type: none\n}\n\nul.lst-kix_kjj132141nex-7 {\n  list-style-type: none\n}\n\nul.lst-kix_2a03qcigu0f2-8 {\n  list-style-type: none\n}\n\n.lst-kix_rtfebb3v4zx2-7>li {\n  counter-increment: lst-ctn-kix_rtfebb3v4zx2-7\n}\n\n.lst-kix_1mz2712tijq9-4>li:before {\n  content: \"\\0025c6   \"\n}\n\n.lst-kix_i70phmy36es7-3>li:before {\n  content: \"\" counter(lst-ctn-kix_i70phmy36es7-3, decimal) \". \"\n}\n\n.lst-kix_i70phmy36es7-5>li:before {\n  content: \"\" counter(lst-ctn-kix_i70phmy36es7-5, lower-roman) \". \"\n}\n\n.lst-kix_byj4xjdm9nqi-8>li:before {\n  content: \"\\0025a0   \"\n}\n\n.lst-kix_1mz2712tijq9-0>li:before {\n  content: \"\\002794   \"\n}\n\n.lst-kix_i70phmy36es7-7>li:before {\n  content: \"\" counter(lst-ctn-kix_i70phmy36es7-7, lower-latin) \". \"\n}\n\n.lst-kix_1mz2712tijq9-2>li:before {\n  content: \"\\0025cf   \"\n}\n\n.lst-kix_i70phmy36es7-6>li {\n  counter-increment: lst-ctn-kix_i70phmy36es7-6\n}\n\nul.lst-kix_ks5ooyhkhmj-4 {\n  list-style-type: none\n}\n\nul.lst-kix_ks5ooyhkhmj-3 {\n  list-style-type: none\n}\n\nul.lst-kix_ks5ooyhkhmj-6 {\n  list-style-type: none\n}\n\nul.lst-kix_ks5ooyhkhmj-5 {\n  list-style-type: none\n}\n\nul.lst-kix_ks5ooyhkhmj-8 {\n  list-style-type: none\n}\n\nul.lst-kix_ks5ooyhkhmj-7 {\n  list-style-type: none\n}\n\n.lst-kix_1s8qgf4ntfy6-8>li:before {\n  content: \"\\0025a0   \"\n}\n\nul.lst-kix_1mz2712tijq9-8 {\n  list-style-type: none\n}\n\n.lst-kix_1s8qgf4ntfy6-2>li:before {\n  content: \"\\0025a0   \"\n}\n\n.lst-kix_1s8qgf4ntfy6-6>li:before {\n  content: \"\\0025cf   \"\n}\n\n.lst-kix_rtfebb3v4zx2-6>li:before {\n  content: \"\" counter(lst-ctn-kix_rtfebb3v4zx2-6, decimal) \". \"\n}\n\n.lst-kix_rtfebb3v4zx2-8>li:before {\n  content: \"\" counter(lst-ctn-kix_rtfebb3v4zx2-8, lower-roman) \". \"\n}\n\n.lst-kix_qthp0cfoiw80-4>li:before {\n  content: \"-  \"\n}\n\n.lst-kix_rtfebb3v4zx2-8>li {\n  counter-increment: lst-ctn-kix_rtfebb3v4zx2-8\n}\n\n.lst-kix_1s8qgf4ntfy6-4>li:before {\n  content: \"\\0025cb   \"\n}\n\n.lst-kix_qthp0cfoiw80-6>li:before {\n  content: \"-  \"\n}\n\nul.lst-kix_1mz2712tijq9-6 {\n  list-style-type: none\n}\n\n.lst-kix_lc6lbngtx2du-8>li:before {\n  content: \"\\0025a0   \"\n}\n\nul.lst-kix_1mz2712tijq9-7 {\n  list-style-type: none\n}\n\nul.lst-kix_1mz2712tijq9-4 {\n  list-style-type: none\n}\n\n.lst-kix_2a03qcigu0f2-5>li:before {\n  content: \"\\0025a0   \"\n}\n\nul.lst-kix_1mz2712tijq9-5 {\n  list-style-type: none\n}\n\nul.lst-kix_1mz2712tijq9-2 {\n  list-style-type: none\n}\n\n.lst-kix_qthp0cfoiw80-8>li:before {\n  content: \"-  \"\n}\n\n.lst-kix_5nqdbtxdbgr4-7>li:before {\n  content: \"\\0025cb   \"\n}\n\nul.lst-kix_1mz2712tijq9-3 {\n  list-style-type: none\n}\n\n.lst-kix_i70phmy36es7-5>li {\n  counter-increment: lst-ctn-kix_i70phmy36es7-5\n}\n\nli.li-bullet-0:before {\n  margin-left: -18pt;\n  white-space: nowrap;\n  display: inline-block;\n  min-width: 18pt\n}\n\nul.lst-kix_1mz2712tijq9-0 {\n  list-style-type: none\n}\n\n.lst-kix_1s8qgf4ntfy6-0>li:before {\n  content: \"\\0025cf   \"\n}\n\nul.lst-kix_1mz2712tijq9-1 {\n  list-style-type: none\n}\n\nol.lst-kix_i70phmy36es7-0 {\n  list-style-type: none\n}\n\n.lst-kix_4z4oebq2d6xw-0>li:before {\n  content: \"\\0025cf   \"\n}\n\nol.lst-kix_i70phmy36es7-2 {\n  list-style-type: none\n}\n\n.lst-kix_2a03qcigu0f2-1>li:before {\n  content: \"\\0025cb   \"\n}\n\n.lst-kix_2a03qcigu0f2-3>li:before {\n  content: \"\\0025cf   \"\n}\n\nol.lst-kix_i70phmy36es7-1 {\n  list-style-type: none\n}\n\nul.lst-kix_dxfyrqkomy19-0 {\n  list-style-type: none\n}\n\nol.lst-kix_i70phmy36es7-4 {\n  list-style-type: none\n}\n\n.lst-kix_4z4oebq2d6xw-2>li:before {\n  content: \"\\0025a0   \"\n}\n\nol.lst-kix_i70phmy36es7-3 {\n  list-style-type: none\n}\n\nul.lst-kix_dxfyrqkomy19-2 {\n  list-style-type: none\n}\n\nol.lst-kix_i70phmy36es7-6 {\n  list-style-type: none\n}\n\nul.lst-kix_dxfyrqkomy19-1 {\n  list-style-type: none\n}\n\nol.lst-kix_i70phmy36es7-5 {\n  list-style-type: none\n}\n\n.lst-kix_4z4oebq2d6xw-4>li:before {\n  content: \"\\0025cb   \"\n}\n\nol.lst-kix_i70phmy36es7-8.start {\n  counter-reset: lst-ctn-kix_i70phmy36es7-8 0\n}\n\nul.lst-kix_ks5ooyhkhmj-0 {\n  list-style-type: none\n}\n\nul.lst-kix_ks5ooyhkhmj-2 {\n  list-style-type: none\n}\n\nul.lst-kix_ks5ooyhkhmj-1 {\n  list-style-type: none\n}\n\nol {\n  margin: 0;\n  padding: 0\n}\n\ntable td,\ntable th {\n  padding: 0\n}\n\n.c9 {\n  margin-left: 36pt;\n  padding-top: 18pt;\n  padding-left: 0pt;\n  padding-bottom: 6pt;\n  line-height: 1.15;\n  page-break-after: avoid;\n  orphans: 2;\n  widows: 2;\n  text-align: justify\n}\n\n.c7 {\n  margin-left: 36pt;\n  padding-top: 18pt;\n  padding-left: 0pt;\n  padding-bottom: 6pt;\n  line-height: 1.0;\n  page-break-after: avoid;\n  orphans: 2;\n  widows: 2;\n  text-align: justify;\n  color: white;\n}\n\n.c20 {\n  margin-left: 36pt;\n  padding-top: 0pt;\n  text-indent: -18pt;\n  padding-bottom: 0pt;\n  line-height: 1.15;\n  orphans: 2;\n  widows: 2;\n  text-align: center\n}\n\n.c17 {\n  margin-left: 36pt;\n  padding-top: 0pt;\n  text-indent: -18pt;\n  padding-bottom: 0pt;\n  line-height: 1.15;\n  orphans: 2;\n  widows: 2;\n  text-align: right\n}\n\n.c2 {\n  margin-left: 36pt;\n  padding-top: 0pt;\n  padding-left: 0pt;\n  padding-bottom: 0pt;\n  line-height: 1.0;\n  orphans: 2;\n  widows: 2;\n  text-align: justify\n}\n\n.c8 {\n  padding-top: 0pt;\n  padding-bottom: 3pt;\n  line-height: 1.15;\n  page-break-after: avoid;\n  orphans: 2;\n  widows: 2;\n  text-align: center\n}\n\n.c1 {\n  color: white;\n  font-weight: 400;\n  text-decoration: none;\n  vertical-align: baseline;\n  font-size: 24px;\n  font-family: \"Montserrat\";\n  font-style: normal\n}\n\n.c25 {\n  -webkit-text-decoration-skip: none;\n  color: #9900ff;\n  font-weight: 700;\n  text-decoration: underline;\n  text-decoration-skip-ink: none;\n  font-size: 20px;  font-family: \"Montserrat\"\n}\n\n.c4 {\n  color: white;\n  font-weight: 700;\n  text-decoration: none;\n  vertical-align: baseline;\n  font-size: 20px;  font-family: \"Montserrat\";\n  font-style: normal\n}\n\n.c26 {\n  padding-top: 20pt;\n  padding-bottom: 6pt;\n  line-height: 1.15;\n  page-break-after: avoid;\n  orphans: 2;\n  widows: 2;\n  text-align: center\n}\n\n.c24 {\n  padding-top: 0pt;\n  padding-bottom: 0pt;\n  line-height: 1.15;\n  orphans: 2;\n  widows: 2;\n  text-align: left\n}\n\n.c10 {\n  padding-top: 0pt;\n  padding-bottom: 0pt;\n  line-height: 1.15;\n  orphans: 2;\n  widows: 2;\n  text-align: justify\n}\n\n.c3 {\n  padding-top: 0pt;\n  padding-bottom: 0pt;\n  line-height: 1.0;\n  orphans: 2;\n  widows: 2;\n  text-align: justify\n}\n\n.c11 {\n  color: white;\n  text-decoration: none;\n  vertical-align: baseline;\n  font-style: normal\n}\n\n.c15 {\n  padding-top: 0pt;\n  padding-bottom: 0pt;\n  line-height: 1.0;\n  text-align: left\n}\n\n.c18 {\n  color: white;\n  text-decoration: none;\n  vertical-align: baseline;\n  font-style: italic\n}\n\n\n.c6 {\n  color: white;\n  font-size: 24px;  font-family: \"Montserrat\";\n  font-weight: 400\n}\n\n.c0 {\n  color: white;\n  font-size: 25px;\n  font-family: \"Montserrat\";\n  font-weight: 700\n}\n\n.c13 {\n  font-weight: 400;\n  font-size: 20px;  font-family: \"Times New Roman\"\n}\n\n.c19 {\n  font-weight: 400;\n  font-size: 22px;  font-family: \"Arial\"\n}\n\n.c22 {\n  font-weight: 400;\n  font-size: 17px;  font-family: \"Arial\"\n}\n\n.c16 {\n  color: white;\n  margin: 5px\n}\n\n.c14 {\n  padding: 0;\n  margin: 0\n}\n\n.c23 {\n  margin-left: 72pt;\n  padding-left: 0pt\n}\n\n\n.c5 {\n  height: 11pt\n}\n\n.title {\n  padding-top: 0pt;\n  color: white;\n  font-size: 22px;  padding-bottom: 3pt;\n  font-family: \"Arial\";\n  line-height: 1.15;\n  page-break-after: avoid;\n  orphans: 2;\n  widows: 2;\n  text-align: left\n}\n\n.subtitle {\n  padding-top: 0pt;\n  color: white;\n  font-size: 18px;  padding-bottom: 16pt;\n  font-family: \"Arial\";\n  line-height: 1.15;\n  page-break-after: avoid;\n  orphans: 2;\n  widows: 2;\n  text-align: left\n}\n\n/*-------------------------------------------------------------------Privacy and more END------------------------------------------------------------*/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
